import { nextTick } from 'vue';

/**
 * Composable for managing third-party form embeds (HubSpot, JotForm, Termly)
 * @returns {Object} Methods to initialize each embed type
 */
export function useFormEmbeds() {
    const embedHubSpotForm = (divId, formId) => {
        const siteSettings = JSON.parse(localStorage.getItem('site_settings') || '{}');
        const portalId = siteSettings.hub_spot_portal_id || '';
        if (!divId || !portalId || !formId) return;

        const script = document.createElement('script');
        script.src = '//js.hsforms.net/forms/v2.js';
        document.body.appendChild(script);
        
        script.addEventListener('load', () => {
            if (window.hbspt) {
                window.hbspt.forms.create({
                    portalId,
                    formId,
                    target: `#${divId}`,
                });
            }
        });
    };

    const embedJotForm = (divId, formId) => {
        if (!divId || !formId) return;

        const insertJotForm = () => {
            const targetElem = typeof divId === 'string' ? document.getElementById(divId) || document.querySelector(divId) : divId;
            if (!targetElem) {
                requestAnimationFrame(insertJotForm);
                return;
            }

            if (!targetElem.dataset.jotformLoaded) {
                const script = document.createElement('script');
                script.src = '//js.jotform.com/JotFormAnywhere.js';
                script.async = true;
                script.onload = () => {
                    if (window.JotformAnywhere) {
                        try {
                            window.JotformAnywhere.insertForm({
                                formID: formId,
                                formEmbedUrl: `https://form.jotform.com/jsform/${formId}`,
                                insertTo: `#${targetElem.id || divId}`,
                                putEditButton: false,
                                putDeleteButton: false,
                            });
                        } catch (err) {
                            console.error("Error embedding JotForm:", err);
                        }
                    }
                };
                document.body.appendChild(script);
                targetElem.dataset.jotformLoaded = "1";
            } else if (window.JotformAnywhere) {
                try {
                    window.JotformAnywhere.insertForm({
                        formID: formId,
                        formEmbedUrl: `https://form.jotform.com/jsform/${formId}`,
                        insertTo: `#${targetElem.id || divId}`,
                        putEditButton: false,
                        putDeleteButton: false,
                    });
                } catch (err) {
                    console.error("Error embedding JotForm:", err);
                }
            }
        };

        insertJotForm();
    };

    const embedTermly = (divId, dataId) => {
        if (!dataId || !divId) return;

        const container = document.getElementById(divId);
        if (!container) return;

        const embedDiv = document.createElement('div');
        embedDiv.setAttribute('name', 'termly-embed');
        embedDiv.setAttribute('data-id', dataId);

        const script = document.createElement('script');
        script.src = 'https://app.termly.io/embed-policy.min.js';

        container.appendChild(embedDiv);
        container.appendChild(script);
    };

    const embedForms = (pageDetails) => {
        if (pageDetails.embeds && pageDetails.embeds.length > 0) {
            nextTick(() => {
                pageDetails.embeds.forEach(embed => {
                    switch (embed.type) {
                        case 'hubspot':
                            embedHubSpotForm(embed.div_id, embed.embed_id);
                            break;
                        case 'jotform':
                            embedJotForm(embed.div_id, embed.embed_id);
                            break;
                        case 'termly':
                            embedTermly(embed.div_id, embed.embed_id);
                            break;
                    }
                });
            });
        }
    };

    return {
        embedHubSpotForm,
        embedJotForm,
        embedTermly,
        embedForms,
    };
}

